export async function fetchPdfBlob(pdfUrl: string): Promise<Blob> {
  const response = await fetch(pdfUrl);
  return await response.blob();
}

function openBlobPdfInNewTab(blobUrl: string, title: string) {
  // Do not pass noopener here — the opener must write iframe markup into the new tab.
  const newWindow = window.open("about:blank", "_blank");
  if (newWindow) {
    try {
      newWindow.document.title = title || "PDF Preview";
      const style = newWindow.document.createElement("style");
      style.textContent =
        "body { margin: 0; padding: 0; overflow: hidden; background-color: #525659; }" +
        "iframe { width: 100vw; height: 100vh; border: none; }";
      newWindow.document.head.appendChild(style);

      const iframe = newWindow.document.createElement("iframe");
      iframe.src = blobUrl;
      iframe.title = "PDF Preview";
      newWindow.document.body.appendChild(iframe);
      return true;
    } catch {
      return false;
    }
  }
  return false;
}

function openPdfUrlWithInlineHint(pdfUrl: string) {
  try {
    const url = new URL(pdfUrl);
    if (url.searchParams.has("response-content-disposition")) {
      url.searchParams.set("response-content-disposition", "inline");
    }
    window.open(url.toString(), "_blank", "noopener,noreferrer");
  } catch {
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  }
}

/**
 * Open a PDF in a new browser tab for inline preview (not download).
 * Fetches as blob first to bypass S3 `Content-Disposition: attachment`.
 */
export async function openPdfUrlInNewTabForPreview(
  pdfUrl: string,
  title = "PDF Preview",
): Promise<void> {
  try {
    const blob = await fetchPdfBlob(pdfUrl);
    const blobUrl = window.URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" }),
    );
    const opened = openBlobPdfInNewTab(blobUrl, title);
    if (!opened) {
      window.open(blobUrl, "_blank", "noopener,noreferrer");
    }
  } catch (error) {
    console.error("Failed to open PDF as blob (likely CORS):", error);
    openPdfUrlWithInlineHint(pdfUrl);
  }
}
